import { createSlice } from '@reduxjs/toolkit';

// Auth state is hydrated from the server at app boot (see bootstrapRequest
// in authSaga). The HttpOnly cookie is the source of truth — JS can't read
// it, so we ask /auth/me whether it's still valid rather than keeping a
// localStorage hint that can lie about the actual session state.
const initialState = {
  loading: false,
  bootstrapped: false,  // false until /auth/me has returned at least once
  error: null,
  isLoggedIn: false,
  userData: null,
  res: null,
  resetPasswordRes: null,
  updatePasswordRes: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Fired on app mount; saga calls /auth/me and dispatches the matching
    // success/failure below. Until one of those lands, bootstrapped=false.
    bootstrapRequest: (state) => {
      state.loading = true;
    },
    bootstrapResolved: (state, action) => {
      state.loading = false;
      state.bootstrapped = true;
      if (action.payload?.user) {
        state.isLoggedIn = true;
        state.userData = action.payload.user;
      } else {
        state.isLoggedIn = false;
        state.userData = null;
      }
    },

    loginRequest: (state) => {
      state.loading = true;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isLoggedIn = true;
      state.res = action.payload;
      state.userData = action.payload.userData;
      state.bootstrapped = true;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.res = action.payload;
      state.isLoggedIn = false;
      state.userData = null;
    },
    resetLoginRequest: (state) => {
      state.res = null;
    },
    resetPasswordRequest: (state) => {
      state.loading = true;
    },
    resetPasswordSuccess: (state, action) => {
      state.loading = false;
      state.resetPasswordRes = action.payload;
    },
    resetPasswordFailure: (state, action) => {
      state.loading = false;
      state.resetPasswordRes = action.payload;
    },
    resetPasswordData: (state) => {
      state.loading = false;
      state.resetPasswordRes = null;
    },

    updatePasswordRequest: (state) => {
      state.loading = true;
    },
    updatePasswordSuccess: (state, action) => {
      state.loading = false;
      state.updatePasswordRes = action.payload;
    },
    updatePasswordFailure: (state, action) => {
      state.loading = false;
      state.updatePasswordRes = action.payload;
    },
    ressetUpadtePassword: (state) => {
      state.loading = false;
      state.updatePasswordRes = null;
    },

    logoutRequest: (state) => {
      state.loading = true;
    },
    logoutSuccess: (state) => {
      state.loading = false;
      state.isLoggedIn = false;
      state.res = null;
      state.userData = null;
    },
  },
});

export const {
  bootstrapRequest,
  bootstrapResolved,
  loginRequest,
  loginSuccess,
  loginFailure,
  resetLoginRequest,
  logoutRequest,
  logoutSuccess,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetPasswordFailure,
  updatePasswordRequest,
  updatePasswordSuccess,
  updatePasswordFailure,
  resetPasswordData,
  ressetUpadtePassword,
} = authSlice.actions;

export default authSlice.reducer;
